import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialScannableCodesState } from './initialState'

const slice = createSlice({
  name: 'scannableCodes',
  initialState: initialScannableCodesState,
  reducers: {
    setInstoreScanningEnabled: (state, action: PayloadAction<boolean>) => {
      state.instoreScanningEnabled = action.payload
    },
    resetForm: (
      state,
      action: PayloadAction<{
        instoreScanningEnabled: boolean
        supportsInstoreScanning: boolean
      }>
    ) => {
      state.instoreScanningEnabled = action.payload.instoreScanningEnabled
      state.isFormDisabled = !action.payload.supportsInstoreScanning
    },
    setFormSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitting = action.payload
    },
  },
})

export const reducer = slice.reducer
export const { setFormSubmitting, setInstoreScanningEnabled, resetForm } =
  slice.actions
